//
import { date, required } from '@/services/validations'
import UserModel from '@/models/General/GUser'

//
import DetailDispatchRequestBatchHeaders from '@/views/Warehouse/WhDispatchRequestBatch/reception/headers'

//
export default () => [
    {
        name: 'supervisor_g_user_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Responsable',
            model: UserModel,
            noDataText: 'Sin empleados.',
            noObject: true,
            readonly: true,
            rules: [required],
        },
    },
    {
        name: 'created_at',
        type: 'date-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            fieldProps: {
                rules: [date, required],
            },
            label: 'Creado',
            pickerProps: {
                readonly: true,
            },
        },
    },
    {
        name: 'dispatch_date',
        type: 'date-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            fieldProps: {
                rules: [date, required],
            },
            label: 'Despacho',
        },
    },
    {
        name: 'g_state_name',
        type: 'text-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Estado',
            readonly: true,
            rules: [required],
        },
    },
    {
        name: 'wh_selected_dispatch_request_batch',
        type: 'data-table-model',
        flex: {
            'd-grid': true,
            'pt-0': true,
            xs12: true,
        },
        props: {
            checkable: true,
            class: 'v-card elevation-2 mb-4',
            headers: DetailDispatchRequestBatchHeaders,
            noActions: true,
            noDataText: 'Sin solicitudes de despacho.',
            noFilter: true,
            noExport: true,
            noHelper: true,
            noPagination: true,
            noSearch: true,
            showNativePagination: true,
            toolbarTitle: 'Lista de solicitudes de despacho',
            toolbarColor: 'primary',
            toolbarDark: true,
            toolbarDense: true,
            rules: [required],
        },
    },
    {
        name: 'description',
        type: 'textarea',
        flex: {
            xs12: true,
        },
        props: {
            noDataText: 'Sin empleados.',
            label: 'Descripción',
            readonly: true,
            rules: [required],
        },
    },
]
